<template lang="pug">
  .selectAGroup
    i.fa.fa-refresh.fa-spin.grey(v-if='!groupsAndType')
      //- li(v-for='typeAndGroups in groups', @click=' selectGroup(group)')
      //-   vue-object-img(:object='group')
      //-   .name {{group.name}}
    section(v-for='(typeAndGroups, key) in groupsAndType')
      .groupType
        i.fa(:class='key | groupTypeIcon')
        |  {{$t('groups.types.'+key)}}
        template(v-if='typeAndGroups.inactive.length > 0')
          i.fa.fa-eye-slash.notRecentlyUsedBtn(v-if="hideInactiveGroupOfType(key)", title="Afficher les groupes non utilisés", @click=' toggleShowInactiveGroupOfType(key, $event)')
          i.fa.fa-eye.notRecentlyUsedBtn(v-if='showInactiveGroupOfType(key)', title="Cacher les groupes non utilisés", @click=' toggleShowInactiveGroupOfType(key, $event)')
      ul
        li(v-for='group in typeAndGroups.active', @click='selectGroup(group)')
          vue-object-img(:object='group')
          .name  {{group.name}}
        template(v-if='showInactiveGroupOfType(key)')
          li(v-for='group in typeAndGroups.inactive', @click=' selectGroup(group)')
            vue-object-img(:object='group')
            .name  {{group.name}}
        template(v-else)
          li(v-if='typeAndGroups.active.length == 0')
    li.createAGroup(@click='createGroup()')
      i.fa.fa-plus.grey
      | {{$t('groups.createAGroup')}}...
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment'

import {groupTypeIcon} from '@/components/shared/vue.globals'

import VueObjectImg from '@/components/shared/VueObjectImg'
import modalsBus from '@/components/shared/ModalsBus'

export default {
  props: {
    filterGroups: {
      type: Function,
      default: (group) => true
    }
  },
  data () {
    return {
      inactiveGroupsOfType: []
    }
  },
  components: {
    VueObjectImg
  },
  filters: {
    groupTypeIcon
  },
  computed: {
    ...mapGetters('groops', [
      'groops'
    ]),
    groupsAndType () {
      const groupsAndType = {}
      const sixMonth = moment().subtract(6, 'month').unix()

      for (let group of Array.from(this.groops)) {
        if (this.filterGroups(group)) {
          groupsAndType[group.type] = groupsAndType[group.type] || {active: [], inactive: []}
          if (group.lastNotificationTime < sixMonth) {
            groupsAndType[group.type].inactive.push(group)
          } else {
            groupsAndType[group.type].active.push(group)
          }
        }
      }
      return groupsAndType
    }
  },
  methods: {
    hideInactiveGroupOfType (t) {
      return !Array.from(this.inactiveGroupsOfType).includes(t)
    },

    showInactiveGroupOfType (t) {
      return Array.from(this.inactiveGroupsOfType).includes(t)
    },

    selectGroup (group) {
      this.$emit('select-group', group)
    },

    toggleShowInactiveGroupOfType (t, event) {
      event.stopPropagation()
      if (Array.from(this.inactiveGroupsOfType).includes(t)) {
        const index = this.inactiveGroupsOfType.indexOf(t)
        this.inactiveGroupsOfType.splice(index, 1)
      } else {
        this.inactiveGroupsOfType.push(t)
      }
      return
    },
    createGroup () {
      modalsBus.closeAll()
      modalsBus.open(modalsBus.modals.CREATE_GROUP)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectAGroupDiv.vue?bfa7e09e